import React, { useEffect, useState } from 'react'
import { Box, IconButton } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

function ModalHistoryProjectParticipation({ onClose, data }) {

    useEffect(() => {
        console.log(data)
    }, [])

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (
        <>
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>ประวัติการเข้าร่วมโครงการ</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px', margin: '10px 0' }}>
                        <Box sx={{ fontWeight: 600 }}>ชื่อโครงการ</Box>
                        {data.map((i, idx) => (
                            <Box sx={{
                                border: '1px solid #AEB4DD',
                                borderRadius: '10px',
                                padding: '15px'
                            }}
                                key={idx}
                            >
                                <Box><FiberManualRecordIcon sx={{ fontSize: '10px' }} /> {i['project_name']}</Box>
                                <Box sx={{ paddingLeft: '10px' }}>{convertDate(i['join_date'])}</Box>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalHistoryProjectParticipation
